import React from 'react';

import ChartCard from './ChartCard';
import { fmtNumber, exportRowsToCsv } from './chartTheme';

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const dropDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
};

// Who dropped out of this cohort and why. Reasons are free text (each one is
// unique), so a name + reason list reads far better than grouped-count bars.
const DroppedLeadsCard = ({
  drops = [],
  received = 0,
  filenameSuffix,
  loading,
}) => {
  const pct = received > 0 ? Math.round((drops.length / received) * 100) : 0;

  const handleExport = () =>
    exportRowsToCsv(
      `leads-dropped_${filenameSuffix}`,
      drops.map((d) => ({
        Name: d.name,
        Reason: d.reason || '',
        'Dropped At': d.droppedAt,
        Source: d.sourceSystem,
      })),
    );

  return (
    <ChartCard
      title="Dropped leads"
      caption="Leads from this period's cohort that were dropped, and why."
      onExport={handleExport}
    >
      {loading ? (
        <div className="space-y-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="h-8 animate-pulse rounded-md bg-muted" />
          ))}
        </div>
      ) : drops.length === 0 ? (
        <div className="flex h-full min-h-24 items-center justify-center text-sm text-muted-foreground">
          No dropped leads in this period. 🎉
        </div>
      ) : (
        <div className="flex h-full flex-col">
          <div className="mb-2 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground">
              {fmtNumber(drops.length)}
            </span>
            <span className="text-xs text-muted-foreground">
              dropped · {pct}% of leads received
            </span>
          </div>
          <div className="max-h-72 min-h-0 flex-1 divide-y divide-border/70 overflow-y-auto">
            {drops.map((d, i) => (
              <div
                key={i}
                className="flex items-start justify-between gap-3 py-2"
              >
                <div className="min-w-0">
                  <div className="truncate text-sm font-medium text-foreground">
                    {d.name}
                  </div>
                  <div className="text-xs leading-snug text-muted-foreground">
                    {d.reason || 'No reason given'}
                  </div>
                </div>
                <div className="shrink-0 pr-3 pt-0.5 text-xs text-muted-foreground">
                  {dropDate(d.droppedAt)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </ChartCard>
  );
};

export default DroppedLeadsCard;
